import { Field } from "@headlessui/react";
import { EnvelopeIcon, PaperAirplaneIcon } from "@heroicons/react/24/outline";
import ButtonWithConfirm from "../../../../components/ButtonWithConfirm";
import {
	EditUserViewModel,
	ResendWelcomeEmailModel,
	useResendWelcomeEmailMutation,
} from "../../usersApiSlice";

interface ResendWelcomeEmailProps {
	userInfo: EditUserViewModel;
	setSuccessMessage: (message: string) => void;
	setErrorMessage: (message: string) => void;
}

export default function ResendWelcomeEmail(props: ResendWelcomeEmailProps) {
	const resendModel: ResendWelcomeEmailModel = {
		userId: props.userInfo.id,
		districtName: props.userInfo.districts?.[0]?.name ?? "",
		schoolName: props.userInfo.schools?.[0]?.name ?? "",
	};

	const [resend] = useResendWelcomeEmailMutation();

	function handleConfirm() {
		resend(resendModel)
			.unwrap()
			.then((message) => {
				props.setErrorMessage("");
				props.setSuccessMessage(message);
			})
			.catch((error) => {
				props.setSuccessMessage("");
				props.setErrorMessage(error.data);
			})
			.finally(() => scrollTo(0, 0));
	}

	return (
		<div className="flex items-center">
			<EnvelopeIcon className="size-18 shrink-0" />
			<div className="ml-4">
				<p>Resend Welcome Email:</p>
				<Field className="flex items-center ml-2 mt-1">
					<ButtonWithConfirm
						id="resend-welcome-email-button"
						className="btn btn-action"
						title="Wait!"
						message="Resending the welcome email will generate a new password. Are you sure you would like to resend it?"
						confirmLabel="Yes"
						cancelLabel="No"
						onConfirm={handleConfirm}>
						<span className="flex items-center">
							<PaperAirplaneIcon className="size-4 mr-2" /> Send
						</span>
					</ButtonWithConfirm>
				</Field>
			</div>
		</div>
	);
}
